import React, { useEffect, useRef, useState } from "react";
import { nanoid } from "nanoid";
import ConfirmModal from "../../ConfirmModal";

function AutoGrowTextarea({ value, onSave, placeholder }) {
  const [localValue, setLocalValue] = useState(value || "");
  const ref = useRef(null);

  useEffect(() => {
    setLocalValue(value || "");
  }, [value]);

  useEffect(() => {
    if (!ref.current) return;
    ref.current.style.height = "auto";
    ref.current.style.height = `${ref.current.scrollHeight}px`;
  }, [localValue]);

  return (
    <textarea
      ref={ref}
      className="lato-textarea form-control"
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      onBlur={() => onSave(localValue)}
      placeholder={placeholder}
      style={{
        resize: "none",
        overflow: "hidden",
        width: "100%",
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
        fontFamily: "Lato, sans-serif",
      }}
    />
  );
}

export default function SuositeltavatLisatutkimukset({
  data = {},
  onChange,
}) {
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    rowIndex: null,
  });

  const [items, setItems] = useState(
    (data.items || []).map((it) => ({
      id: it.id || nanoid(),
      text: it.text || "",
    }))
  );

  useEffect(() => {
    setItems(
      (data.items || []).map((it) => ({
        id: it.id || nanoid(),
        text: it.text || "",
      }))
    );
  }, [data.items]);

  const commit = (next) => {
    setItems(next);
    onChange?.({ ...data, items: next });
  };

  const updateItem = (idx, patch) => {
    const next = items.map((it, i) =>
      i === idx ? { ...it, ...patch } : it
    );
    commit(next);
  };

  const addItem = () => {
    commit([
      ...items,
      {
        id: nanoid(),
        text: "",
      },
    ]);
  };

  const removeItem = (idx) => {
    commit(items.filter((_, i) => i !== idx));
  };

  return (
    <>
      <div className="border rounded p-3 bg-white">
        {items.map((row, i) => (
          <div
            key={row.id}
            className="mb-3 p-3 border rounded bg-light d-flex flex-column flex-md-row align-items-stretch align-items-md-start gap-2"
          >
            <AutoGrowTextarea
              value={row.text}
              onSave={(value) => updateItem(i, { text: value })}
              placeholder="Kirjoita suositeltava lisätutkimus..."
            />

            <button
              type="button"
              className="btn btn-outline-danger btn-sm align-self-md-start"
              onClick={() =>
                setConfirmModal({
                  show: true,
                  rowIndex: i,
                })
              }
            >
              Poista
            </button>
          </div>
        ))}

        <div className="text-end mt-2">
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={addItem}
          >
            + lisää lisätutkimus
          </button>
        </div>
      </div>

      <ConfirmModal
        show={confirmModal?.show}
        title="Poista rivi"
        message="Haluatko varmasti poistaa tämän lisätutkimuksen?"
        confirmText="Poista"
        cancelText="Peruuta"
        confirmVariant="danger"
        onClose={() =>
          setConfirmModal({ show: false, rowIndex: null })
        }
        onConfirm={() => {
          if (confirmModal?.rowIndex != null) {
            removeItem(confirmModal.rowIndex);
            setConfirmModal({
              show: false,
              rowIndex: null,
            });
          }
        }}
      />
    </>
  );
}